/**
 * Created by lihanying on 2017/6/26.
 */
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import * as actions from './action'
import Storage from './component/storage'

class ClubStorage extends React.Component {
  static defaultProps = {
    storageType: {
      list: [],
    },
    storageList: [],
  }
  state = {
    loading: true,
  }

  componentWillUnmount() {
    this.props.getClubStorage([]) //清除
  }

  render() {
    const { storageList, storageType } = this.props
    return (
      <Storage
        list={storageList}
        storageType={storageType}
        fetchClubStorage={this.props.fetchClubStorage}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    storageType: state.getClubCommodityType.clubCommodityType,
    storageList: state.getClubStorage.storageList,
  }
}
export default withRouter(connect(mapStateToProps, actions)(ClubStorage))



// WEBPACK FOOTER //
// ./src/containers/ClubStorage/index.js